/**
 * @method replaceParam
 * @description 替换str中的标记
 * @param str {String} xxxxxxx{str}bbbbbb{str2}
 * @param replaceArr {Array} [{reg: 'str', value: '东邪'}, {reg: 'str2', value: '郭靖'}]
 * 
 * @return xxxxxxx东邪bbbbbb郭靖
 */
let replaceParam = (str, replaceArr) => {
    for(let i in replaceArr) {
        let {reg, value} = replaceArr[i];
        if (!reg) continue;
        let regExp = new RegExp('{' + reg + '}', 'g');
        str = str.toString().replace(regExp, value);
    }
    return str;
};

export {replaceParam};


// WEBPACK FOOTER //
// ./src/common/global/index.js